import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IAbstractView } from '@core/interfaces';
import { SingleproductHeaderPresenter } from './singleproduct-header.presenter';
import { ISingleproductHeaderComponent } from './interfaces';

@Component({
  selector: 'app-singleproduct-header',
  templateUrl: './singleproduct-header.component.html',
  styleUrls: ['./singleproduct-header.component.scss'],
  standalone: false,
  providers: [SingleproductHeaderPresenter]
})
export class SingleproductHeaderComponent 
  extends IAbstractView<SingleproductHeaderPresenter> 
  implements ISingleproductHeaderComponent 
{
  @Input() formGroup!: FormGroup;
  @Input() decimalPrecision: string = '';
  @Input() isLongMode = false;
  readonly no_image = 'assets/plato-no-image.svg';
  private failedImageUrl: string | null = null;

  constructor(presenter: SingleproductHeaderPresenter) {
    super(presenter);
  }

  get articleImage(): string {
    const imageUrl = this.formGroup?.get('productosCanal.imagen')?.value as string | null;
    return imageUrl && imageUrl !== this.failedImageUrl ? imageUrl : this.no_image;
  }

  get articleDescription(): string | null {
    return this.formGroup?.get('productosCanal.descripcion')?.value ?? null;
  }

  get precio(): bigint {
    return this.formGroup?.get('precio')?.value ?? 0n;
  }

  onImageError(): void {
    this.failedImageUrl = this.formGroup?.get('productosCanal.imagen')?.value ?? null;
  }

  shouldShowPriceOptions(): boolean {
    return this.presenter.shouldShowPriceOptions();
  }

  get quantityDecreaseIcon(): 'trash' | 'minus' {
    return this.presenter.quantityDecreaseIcon();
  }

  async showFullImage(imageUrl: string): Promise<void> {
    await this.presenter.showFullImage(imageUrl);
  }

  decreaseMealSelected(): void {
    this.presenter.decreaseMealSelected();
  }

  increaseMealSelected(): void {
    this.presenter.increaseMealSelected();
  }
}